<template>
  <div class="tariff">
    <div class="tariff-hd">
      <div class="title">新注册会员</div>
      <div class="subtitle">
        <i class="iconfont iconliwu"></i>即可获得
        <span style="font-size: 20px">￥3000</span>
        元大礼包，考试100人，面试6人
      </div>
    </div>
    <div class="tariff-bd">
      <div :class="{ 'tariff-bd-top': true, 'stop-hd': stopHd }">
        <hd-cell
          v-for="(item, index) in isMobile ? cptHdData.slice(0, 3) : cptHdData"
          :key="index"
          :item="item"
          :index="index"
          :activeRowIndex="activeRowIndex"
          @mouseenter.native="onMouseEnter(index)"
          @mouseleave.native="onMouseLeave()"
        />
      </div>
      <div class="container" :style="{ 'padding-top': stopHd ? '150px' : 0 }">
        <div class="box">
          <title-type :quesType="quesType" />
          <bd-cell
            v-for="(i, key) in !stopHd && isMobile
              ? cptNewBdData.slice(0, 2)
              : cptNewBdData"
            :key="key"
            :list="i"
            :index="key"
            :activeRowIndex="activeRowIndex"
            @mouseenter.native="onMouseEnter(key + 1)"
            @mouseleave.native="onMouseLeave()"
          ></bd-cell>
        </div>
      </div>
    </div>

    <div
      v-if="isMobile"
      class="tariff-bd"
      id="mobile-tariff2"
      style="margin-top: 32px"
    >
      <div :class="{ 'tariff-bd-top': true, 'stop-hd': stopHd2 }">
        <hd-cell
          v-for="(item, index) in cptIsMobile2HdData"
          :key="index"
          :item="item"
          :index="index"
          :activeRowIndex="activeRowIndex"
          @mouseenter.native="onMouseEnter(index + 2)"
          @mouseleave.native="onMouseLeave()"
        />
      </div>
      <div
        class="container"
        :style="{ 'padding-top': stopHd && !isMobile ? '150px' : 0 }"
      >
        <div class="box">
          <title-type :quesType="quesType" />
          <bd-cell
            v-for="(i, key) in cptNewBdData.slice(2, 4)"
            :key="key"
            :list="i"
            :index="key"
            :stopHd="stopHd"
            :activeRowIndex="activeRowIndex"
            @mouseenter.native="onMouseEnter(key + 3)"
            @mouseleave.native="onMouseLeave()"
          ></bd-cell>
        </div>
      </div>
    </div>
    <div class="tariff-bottom" id="tariff-bottom">
      <bottom-desc :qaData="qaData" :type="type" />
    </div>
    <div class="bottom-pic">
      <div class="bottom-pic-hd">不知道如何选择会员？</div>
      <div class="bottom-pic-bd">
        咨询产品详细功能，<span v-if="isMobile"><br /></span
        >产品演示、价格，实施服务等产品相关问题
      </div>
      <div class="bottom-pic-bd">
        可致电咨询专业顾问：<span class="blue" v-html="webconfig.Landline"
          >400-060-8006</span
        >
      </div>
      <div class="bottom-btns">
        <a class="btn-blue-hover" @click="onApply">申请体验 </a>
        <a type="primary" @click="onAsk"> 在线咨询顾问</a>
      </div>
    </div>
    <us-pc-dialog
      :dialogVisible="isPcDialogShow"
      :dialogWidth="isMobile ? '98%' : '820px'"
      @cancel="isPcDialogShow = false"
    />
  </div>
</template>
<script>
import HdCell from './hd-cell/index'
import TitleType from './title-type/index'
import BdCell from './bd-cell/index'
import BottomDesc from './bottom-desc/index'
import { hdData, newBdData } from './config'
import { LOGIN_API } from "@/api.js";
export default {
  name: 'tariff',
  props: ['type'],
  data() {
    return {
      activeRowIndex: 3,
      //头部固定
      stopHd: false,
      stopHd2: false,

      cptHdData: [],
      titles: '',
      cptNewBdData: [],
      qaData: '',
      quesType: '',

      webconfig: {},

      isPcDialogShow: false,
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.app.device
    },
    cptIsMobile1HdData() {
      return this.cptHdData.filter((item, index) => {
        return !this.isMobile || (this.isMobile && index < 3)
      })
    },
    cptIsMobile2HdData() {
      return this.cptHdData.filter((item, index) => {
        return this.isMobile && (index == 0 || (index >= 3 && index < 5))
      })
    },

    loadConfig() {
      return this.$store.state.app.config
    },
  },
  components: {
    HdCell,
    TitleType,
    BdCell,
    BottomDesc,
  },
  mounted() {
    this.listenBodyScroll()
    this.cptHdData = hdData
    this.cptNewBdData = newBdData
    this.loadDate()
    if (this.$store.state.app.config && this.$store.state.app.config.concat) {
      this.webconfig = this.$store.state.app.config.concat
    }
    window.scrollTo(0, 0)
    if (this.isMobile) {
      this.activeRowIndex = 1
    }
  },
  watch: {
    loadConfig(newVal, oldVal) {
      if (newVal.concat) {
        this.webconfig = newVal.concat
      }
    },
  },
  destroyed() {
    this.stopListenBodyScroll()
  },
  methods: {
    onMouseEnter(e) {
      this.activeRowIndex = e
    },
    onMouseLeave(e) {
      return
      if (this.isMobile) {
        return
      }
      this.activeRowIndex = 3
    },
    //增加监听器
    listenBodyScroll() {
      window.addEventListener('scroll', this.onBodyScroll)
    },
    //监听
    onBodyScroll() {
      // if(this.isMobile){
      //   return;
      // }
      let height =
        document.getElementById('app').height ||
        document.getElementById('app').clientHeight
      if (window.pageYOffset > 230) {
        this.stopHd = true
      }
      if (window.pageYOffset <= 230 || window.pageYOffset > height - 1300) {
        this.stopHd = false
      }
      if (this.isMobile) {
        this.stopHd = false
        this.stopHd2 = false
      }
    },
    //销毁监听器
    stopListenBodyScroll() {
      window.removeEventListener('scroll', this.onBodyScroll)
    },
    loadDate() {
      let post = {
        category: 32,
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/config`, post)
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.result && res.data.result.length > 0) {
              let data = res.data.result[0].data
              let result = [[], [], [], [], []]
              let type = this.type
              data[type].list.map((item, index) => {
                result[0].push({
                  type: isNaN(item.value[0]) ? 0 : parseInt(item.value[0]) + 1,
                  value: item.value[0],
                })
                result[1].push({
                  type: isNaN(item.value[1]) ? 0 : parseInt(item.value[1]) + 1,
                  value: item.value[1],
                })
                result[2].push({
                  type: isNaN(item.value[2]) ? 0 : parseInt(item.value[2]) + 1,
                  value: item.value[2],
                })
                result[3].push({
                  type: isNaN(item.value[3]) ? 0 : parseInt(item.value[3]) + 1,
                  value: item.value[3],
                })
                result[4].push({
                  type: isNaN(item.value[4]) ? 0 : parseInt(item.value[4]) + 1,
                  value: item.value[4],
                })
              })
              if (this.isMobile) {
                this.cptNewBdData = result.map((item) => {
                  return item.filter((i, index) => {
                    return index < 3
                  })
                })
                if (this.type == 'exam') {
                  let items = this.cptNewBdData
                  items[0].splice(1, 0, { type: 0, value: '企业版' })
                  items[1].splice(1, 0, { type: 0, value: '企业版' })
                  items[2].splice(1, 0, { type: 0, value: '企业版' })
                  items[3].splice(1, 0, { type: 0, value: '企业版' })
                  this.cptNewBdData = items
                }
              } else {
                this.cptNewBdData = result
              }
              this.qaData =
                this.type == 'interview'
                  ? data[type].qa.filter((item, index) => {
                      return index != 6
                    })
                  : data[type].qa
              if (this.isMobile && this.type == 'exam') {
                this.quesType = data[type].left
                  .map((item) => {
                    if (item.label == '基本') {
                      return {
                        ...item,
                        value: ['考生人数', '功能版本', '附赠套餐', '有效期'],
                      }
                    }
                    return item
                  })
                  .filter((item, index) => index < 1)
              } else if (this.isMobile && this.type == 'interview') {
                this.quesType = data[type].left.filter(
                  (item, index) => index < 1
                )
              } else {
                this.quesType = data[type].left
              }
              this.cptHdData = data[type].titles
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
    //申请体验
    onApply() {
      if (this.isMobile) {
        this.isPcDialogShow = true
      } else {
        this.$bus.emit('compRegisterChoose')
      }
    },
    // 在线咨询顾问
    onAsk() {
      this.$bus.emit('chatShow')
    },
  },
}
</script>
<style lang="scss" scoped>
.tariff {
  background: url('~@/static/images/tariff-banner-bg.png') no-repeat center top;
  .tariff-hd {
    color: #333;
    text-align: center;
    padding: 40px 0 0 0;
    font-size: 14px;
    .subtitle {
      padding: 0px 65px;
    }
    .iconliwu {
      padding: 0 10px;
      color: #ff691f;
      font-size: 16px;
    }
    span {
      color: #ff691f;
      font-weight: bold;
    }
    .title {
      font-size: 26px;
      padding-bottom: 20px;
      font-weight: 300;
    }
  }
  width: 100%;
  background-color: #fff;
  .tariff-bd {
    width: 1200px;
    margin: auto;
    box-shadow: 0px 14px 12px 6px #eff0f2;
    margin-top: 50px;
    .tariff-bd-top {
      display: flex;
    }
    .stop-hd {
      width: 1200px;
      top: 60px;
      background: white;
      position: fixed;
      z-index: 200;
    }
  }
  .container {
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      color: transparent;
      display: none;
    }
    .box {
      display: flex;
    }
  }
  .tariff-bottom {
    width: 100%;
    margin-top: 30px;
    background: #f7f8fd url('/static/images/bbg.png') repeat-x;
    padding: 40px 0 40px 0;
  }
  .bottom-pic {
    background: url('~@/static/images/foot-top.png') no-repeat center bottom;
    width: 100%;
    height: 300px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    .bottom-pic-hd {
      font-size: 24px;
      padding: 45px 0 30px 0;
      font-weight: 300;
    }
    .bottom-pic-bd {
      padding: 5px 0;
    }
    .blue {
      color: #29bdb9;
      font-weight: bold;
    }
    .bottom-btns {
      padding: 50px 0px 0px;
      a {
        padding: 6px 30px;
        cursor: pointer;
        color: #fff;
        border: 2px solid #fff;
        border-radius: 2px;
        margin-right: 20px;
        &:hover {
          border: 2px solid #29bdb9;
          background: #29bdb9;
          color: #fff;
        }
        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .tariff {
    .tariff-bd {
      width: initial;
      .tariff-bd-top {
        display: flex;
        .hd-cell {
          width: 33.3%;
          .normal-box {
            .el-button {
              margin-top: 1px !important;
            }
          }
        }
      }
      .container {
        overflow-x: hidden;
        .title-type {
          width: 33.3%;
        }
        .bd-cell {
          width: 33.3%;
          .bd-cell-item {
            width: initial;
          }
        }
        .no-shadow {
          box-shadow: 0px 0px 0px #edf5f5 !important;
        }
      }
      .stop-hd {
        width: 100%;
      }
    }
  }
  .bottom-desc {
    width: initial;
    padding: 0px 15px;
  }
  .bottom-pic-bd {
    padding: 10px 0 !important;
  }
  .bottom-btns {
    padding: 30px 0 0 !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .tariff {
    .tariff-bd {
      width: initial;
      .tariff-bd-top {
        display: flex;
        .hd-cell {
          width: 33.3%;

          .normal-box {
            .el-button {
              margin-top: 1px !important;
            }
          }
        }
      }

      .container {
        overflow-x: hidden;
        .title-type {
          width: 33.3%;
        }
        .bd-cell {
          width: 33.3%;
        }
        .no-shadow {
          box-shadow: 0px 0px 0px #edf5f5 !important;
        }
      }
      .stop-hd {
        width: 100%;
      }
    }
  }
  .bottom-desc {
    width: initial;
    padding: 0px 15px;
  }
  .bottom-pic-bd {
    padding: 10px 0 !important;
  }
  .bottom-btns {
    padding: 30px 0 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tariff/index.vue